import { Box, Typography } from "@mui/material";
import React from "react";

function NoAssessments() {
  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2rem",
      }}
      my={2}
    >
      <Typography variant="h4">Uh-oh!</Typography>

      <Typography variant="h5">There are no assessments</Typography>
      <Typography variant="body1">
        There are no assessments for this School, Department, and Year. But fear
        not, simply complete the assessment form to create a new assessment.
      </Typography>
    </Box>
  );
}

export default NoAssessments;
